import { supabaseClient } from "@/lib/supabase";
import { useQuery } from "@tanstack/react-query";
import { validate as validateUUID } from "uuid";

export const createDiaryLockedKey = (diaryId: string | null | undefined) => ["diary-locked", diaryId] as const;

/** True when the diary has been signed off via lock_diary(). */
export const useDiaryLocked = (diaryId: string | null | undefined) => {
    const query = useQuery({
        queryKey: createDiaryLockedKey(diaryId),
        queryFn: async () => {
            const { data, error } = await supabaseClient.rpc("is_diary_locked", {
                p_diary_id: diaryId!,
            });
            if (error) throw error;
            return Boolean(data);
        },
        enabled: Boolean(diaryId) && validateUUID(diaryId ?? ""),
        staleTime: 1000 * 30,
    });

    return {
        isLocked: query.data ?? false,
        isLoading: query.isLoading,
    };
};
